module.exports = __webpack_public_path__ + "static/media/dustbin_icon_hover.7945024d.svg";